<lib-icon-button
    iconName="trash-outline"
    color="var(--ion-color-red)"
    backgroundColor="rgba(var(--ion-color-red-rgb), 0.2)"
    rippleColor="var(--ion-color-red)"
    backgroundHoverColor="var(--ion-color-red)"
    backgroundFocusedColor="var(--ion-color-red)"
    [border]="false"
    (onClick)="onButtonClick()"
    [size]="20"
    [buttonSize]="40"
    display="square" />
